<script setup lang="ts">
import Main from '@theme/Main.vue'
</script>
<template><Main /></template>
